import qs from 'qs';
import Slider from 'react-slick';
import {connect} from 'react-redux';
import classnames from 'classnames';
import React, {Component} from 'react';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import * as ImageUtils from '../../utils/Image';
import * as ImageConst from '../../constants/Image';
import * as ObjectConst from '../../constants/Property';

class PromoSlider extends Component {
    state = {
        isShowSlider: false
    };

    componentDidMount() {
        // Задержка для слайдера из-за того, что изначально неверно рассчитывается ширина
        setTimeout(() => {
                this.setState({
                    isShowSlider: true
                })
            },
            1000
        );
    }

    getType = () => {
        const params = qs.parse(window.location.search.substring(1));
        let {type} = params;
        const {objectType, searchType} = this.props;
        let response;

        if (type !== undefined) {
            response = type;
        } else {
            if (objectType === ObjectConst.TYPE.RENT || (objectType === ObjectConst.TYPE.ALL && searchType === ObjectConst.TYPE.RENT)) {
                response = ObjectConst.TYPE.RENT;
            } else {
                response = ObjectConst.TYPE.SELL;
            }
        }
        return response;
    };

    getPriceBlock = () => {
        const {i18n, object, objectTypeTerm, currency} = this.props;
        let priceBlock = [];

        if (this.getType() === ObjectConst.TYPE.RENT) {
            if (objectTypeTerm === 'ALL' || objectTypeTerm === 'HOLIDAY') {
                priceBlock.push(
                    <span key={object.id}>
                        {i18n['objectPreview.from']} {object.price.priceRentBase.toLocaleString()} {ObjectConst.CURRENCY[currency].mark} / {i18n['objectPreview.night']}
                    </span>
                )
            } else {
                priceBlock.push(
                    <span key={object.id}>
                        {object.price.priceRentLong.toLocaleString()} {ObjectConst.CURRENCY[currency].mark} / {i18n['objectPreview.month']}
                    </span>
                )
            }
        } else {
            priceBlock.push(
                <span key={object.id}>
                    {object.price.priceSell.toLocaleString()} {ObjectConst.CURRENCY[currency].mark}
                </span>
            )
        }
        return priceBlock;
    };

    getPhoto = () => {
        const {images} = this.props;
        let photo = [];

        if (images !== undefined && images !== null && images.length > 0) {
            const sortedImages = images.slice();
            sortedImages.sort((elem1, elem2) => {
                return elem1.order > elem2.order ? 1 : -1;
            });

            sortedImages.forEach(elem =>
                photo.push(
                    <div
                        key={elem.id}
                        className="promo-slide"
                        style={{backgroundImage: `url(${ImageUtils.getSrc(elem.id, ImageConst.TYPE.RESIZED)})`}}
                    />
                )
            );
        }
        return photo;
    };

    render() {
        const {object} = this.props;
        const sliderSettings = {
            speed: 1000,
            infinite: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            swipeToSlide: true,
            touchThreshold: 100
        };

        return (
            <div className="promo-content">
                <div className="promo-slider">
                    {this.state.isShowSlider && <Slider {...sliderSettings}>
                        {this.getPhoto()}
                    </Slider>}

                    <div className="slide-price-box">
                        {/*eslint-disable*/}
                        <a
                            href=""
                            className={classnames({
                                'bookmark': object.props.rangeType === ObjectConst.RANGE_TYPE.EXCLUSIVE
                            })}
                        />
                        {/*eslint-enable*/}
                        {object.id !== undefined && this.getPriceBlock()}
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => ({
    i18n: state.languages.i18n,
    objectPage: state.objectPage,
    object: state.objectPage.currentObject,
    searchType: state.searchPage.requestParams.type,
    images: state.objectPage.currentObject.meta.images,
    objectType: state.objectPage.currentObject.props.type,
    currency: state.objectPage.currentObject.price.currency,
    objectTypeTerm: state.objectPage.currentObject.props.typeTerm
});

export default connect(mapStateToProps)(PromoSlider);



// WEBPACK FOOTER //
// ./src/components/Base/PromoSlider.js